/* unplugin-vue-components disabled */import { render } from "./xinjiangJszy.vue?vue&type=template&id=00947d49&scoped=true"
import script from "./xinjiangJszy.vue?vue&type=script&lang=js"
export * from "./xinjiangJszy.vue?vue&type=script&lang=js"

import "./xinjiangJszy.vue?vue&type=style&index=0&id=00947d49&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00947d49"]])

export default __exports__